<div #postListContainer class="post-list"
     [style.maxHeight]="height"
     [style.overflow]="overflow" *ngIf="postList.length > 0">
<div #popupcontainer class="popup-card-hover-container"
       id="popupcontainer"
       (panend)="hidePopupCardHover()"
       (clickOutside)="hidePopupCardHover($event)"
       (mouseleave)="hidePopupCardHover()">

    <div #popup class="popup-card-hover post-content" id="popup"></div>
  </div>
  <!-- Masonry grid Container -->
  <ng-masonry-grid
    [masonryOptions]="{columnWidth: '.grid-item', gutter: gutter, horizontalOrder: true, stagger: 0}"
    [useAnimation]="false"
    [useImagesLoaded]="true"
    (onNgMasonryInit)="onNgMasonryInit($event)"
    (layoutComplete)="layoutComplete($event)">
    <!-- Masonry Grid Item -->
    <ng-masonry-grid-item
      id="{{'masonry-item-'+i}}"
      class="grid-item"
      *ngFor="let item of postList; let i = index;">
      <!-- Grid Content  -->
      <a *ngIf="!currentInfluencer" class="post-img-container" [routerLink]="['/dashboard/post', item.urlHash]">
        <img #postImage class="post-img" [ngClass]="{'story-image': item.isStory}"  [src]="item.imageUrl" alt="No image" onerror="this.onerror=null;this.src='assets/images/No_Image.png'" />
      </a>
      <a *ngIf="currentInfluencer" class="post-img-container" [routerLink]="['/dashboard/post', item.urlHash]">
        <img #postImage class="post-img" [ngClass]="{'story-image': item.isStory}"  [src]="item.imageUrl" alt="No image" onerror="this.onerror=null;this.src='assets/images/No_Image.png'" />
      </a>
    </ng-masonry-grid-item>
  </ng-masonry-grid>

</div>
<div class="fade-out-content" *ngIf="postList && height!=='max-content' && !previewMode"></div>
<div class="buttons text-center" *ngIf="postList && height!=='max-content' && !previewMode">
  <button class="button blue show-more-btn" (click)="showMore()">{{ 'INFLUENCER.overview.show_more' | translate }}</button>
</div>



// WEBPACK FOOTER //
// ./src/app/main/influencer/post-list-mansonry/post-list-mansonry.component.html